import { Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import SIcon from "../global/sicon";
import HomeGamesHeaderCardCreateGameButton from "./creategame";
import gameStyles from "../game/gameslist/gameslistgame.module.css";
import styles from "./creategamecard.module.css";

type Props = {
    title: string;
    subtitle: string;
}

export default function HomeCreateGameCard(
    {
        title,
        subtitle,
    }: Props,
): JSX.Element {
    return <Card
        className={`${gameStyles.card} ${styles.card}`}
        elevation={Elevation.FOUR}
    >
        <div className={styles.container}>
            <div className={styles.mapPlaceholder} aria-hidden="true">
                <SIcon icon={IconNames.Map} iconSize={54} />
            </div>
            <div className={styles.content}>
                <div>
                    <h2 className={styles.title}>{title}</h2>
                    <p className={styles.description}>
                        {subtitle}
                    </p>
                </div>
                <HomeGamesHeaderCardCreateGameButton />
            </div>
        </div>
    </Card>;
}
